var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#2B4896"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 16H16V256H256V16Z",
    fill: "#2B4896"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.091 122.344L-6.2373 264.688H18.8877V272.641L139.403 137.422L122.091 122.344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.61646 283.43L125.704 145.236L116.241 146.164V145.727L-4.16479 278.18L1.61646 283.43Z",
    fill: "#E32D3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M255.39 -1.16113L127.062 141.183H152.187V149.136L273.203 14.917L255.39 -1.16113V-1.16113Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260.625 0.735352L135.875 138.001H146V138.438L266.406 5.98535L260.625 0.735352V0.735352Z",
    fill: "#E32D3C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.155 153.048L-6.83875 6.07038L18.2692 6.99656L18.5624 -0.951162L134.548 137.637L116.155 153.048V153.048Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.456 151.346L1.85076 9.57474L11.9689 9.94798L11.985 9.51077L127.427 146.312L121.456 151.346V151.346Z",
    fill: "#E32D3C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M156 16H116V256H156V16Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M155.25 127.043L283.579 269.387H258.454V277.34L137.438 143.121L155.25 127.043V127.043Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M150.016 128.939L274.766 266.205H264.641V266.643L144.235 134.189L150.016 128.939V128.939Z",
    fill: "#E32D3C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M256 156V116H16V156H256Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M148 16H124V256H148V16Z",
    fill: "#E32D3C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M256 148V124H16V148H256Z",
    fill: "#E32D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNz);
export default __webpack_public_path__ + "static/media/NZ.ab2cfc126fc1c1e12302709fb484275d.svg";
export { ForwardRef as ReactComponent };